/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import CityService from "../../services/cityService";
import { Autocomplete, Box, TextField } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

const cacheRtl = createCache({ key: 'muirtl', stylisPlugins: [rtlPlugin] });
const cacheLtr = createCache({ key: 'ltr' });

const CityDropdown = ({ helperText, error, setFormValues, isFilter, selectedCity, setSelectedCity, onChange }) => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();

    const [cities, setCities] = useState([]);

    useEffect(() => {
        const fetchCities = async () => {
            try {
                const data = await CityService.fetchAll();
                setCities(data);
            } catch (error) {
                console.error('Error fetching pages:', error);
            }
        };
        fetchCities();
    }, []);

    return (
        <CacheProvider value={i18n.language === 'en' ? cacheLtr : cacheRtl}>
            <Autocomplete
                options={cities}
                getOptionLabel={(option) => option.name || ""}
                value={selectedCity}
                onChange={onChange ? onChange : (event, newValue) => {
                    setSelectedCity(newValue);
                    setFormValues && setFormValues((prevValues) => ({
                        ...prevValues,
                        cityId: newValue ? newValue.id : null,
                    }));
                }
                }
                renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                        {option.name}
                    </li>
                )}
                renderInput={(params) => (
                    <Box>
                        {
                            !isFilter && <p
                                style={{
                                    color: theme.palette.text.primary,
                                    fontSize: 13,
                                    marginTop: 24,
                                    marginBottom: 4,
                                }}
                            >
                                {t("city")}
                            </p>
                        }

                        <TextField
                            {...params}
                            variant={isFilter ? 'standard' : 'outlined'}
                            fullWidth
                            placeholder={isFilter ? t('city') : t('chooseCity')}
                            error={!!error}
                            helperText={helperText}
                            InputProps={{
                                ...params.InputProps,
                                ...(isFilter ? { disableUnderline: true } : {}),
                                endAdornment: (
                                    <>
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                                style: {
                                    backgroundColor: isFilter ? 'transparent' : theme.palette.customGrey.insideInput,
                                    padding: '6px 8px',
                                },
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: theme.palette.customGrey.borderInput,
                                    },
                                    '&:hover fieldset': {
                                        borderColor: theme.palette.customGrey.borderInput,
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: theme.palette.primary.main,
                                    },
                                },
                                '& .MuiInputBase-input': {
                                    color: theme.palette.text.primary,
                                    padding: '6px 8px',
                                    '&::placeholder': {
                                        fontSize: '14px',
                                        color: theme.palette.text.secondary,
                                        opacity: 1,
                                    },
                                },
                            }}
                        />
                    </Box>
                )}
            />
        </CacheProvider>
    );
}

export default CityDropdown;